import RejectionApprovalNotice from "./RejectionApprovalNotice";
import React, { useState, useEffect, useRef } from "react";
import StartStopJobCardModal from "./StartStopJobCardModal";
import Constants from "../../../../common/Constants";
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import ItemService from "../../../../services/commonService";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import { toastFunc } from "../../../../components/common/util";
import { useNavigate } from "react-router-dom";
import { AlertModal } from "../../../common/AlertModal";
import OkQuantityModal from "./OkQuantityModal";

const ClosecurrentJobCard = () => {
  const navigate = useNavigate();
  const [approval, setApproval] = useState(null);
  const [open, setOpen] = useState(false);
  const [jobcardDetails, setJobcardDetails] = useState(true);
  const [toDeptCode, setToDeptCode] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sizeCode, setSizeCode] = useState("");
  const [okQtyModal, setOkQtyModal] = useState(false);
  const [okActualAmount, setOKActualAmount] = useState(0);
  const [rejectActualAmount, setRejectActualAmount] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [okModalType, setOkModalType] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [okModalTitle, setOkModalTitle] = useState(0);

  const [cummOkCount, setCummOkCount] = useState(0);
  const [cummRejectCount, setCummRejectCount] = useState(0);

  const formRef = useRef(null);
  const { t } = useTranslation();
  const handleClose = () => {
    navigate("/home");
    setOpen(false);
  };

  const handleModalClose = () => {
    setOkQtyModal(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    }, 100);
  }, []);

  const handleOrderConfirmationSuccess = async (decodedText, decodedResult) => {
    if (isProcessing) return; // Prevent multiple calls while processing
    setIsProcessing(true); // Set processing lock
    let param = {
      url: "getTransactionListDataById",
      page: Constants.TRANSACTION.GENERATEJOBCARD.name,
      jobcard: decodedText,
    };

    if (decodedText) {
      try {
        const item = await ItemService.getTransactionListDataById(param);
        if (item?.status === 200) {
          if (
            item?.data.length > 0 &&
            item?.data[0]?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.STOPPED
          ) {
            setOpen(false);
            setJobcardDetails(item.data[0]);
            setSizeCode(item?.data[0]?.sizeCode);
            setToDeptCode(item?.data[0]?.deptCode);

            OrderConfList(item.data[0].jobcard, item?.data[0]?.toDeptCode, item?.data[0]?.order);
          } else {
            if (decodedText === "") {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000
              );
            } else {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                "Jobcard Not Stopped. Please Stop JobCard",
                4000
              );
            }
          }
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      } catch (error) {
        console.error("Error in handleOrderConfirmationSuccess:", error);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
          4000
        );
      } finally {
        setIsProcessing(false); // Reset lock after completion
      }
    } else {
      setIsProcessing(false); // Reset lock if no decodedText is provided
    }
  };

  const getActualAmount = (actAmt, statusCode) => {
    if (statusCode === "OK") {
      setOKActualAmount(actAmt);
    } else if (statusCode === "REJECT") {
      setRejectActualAmount(actAmt);
    }
  };

  const handleOrderConfError = (errorMessage) => {
    console.error(" handleOrderConfError:", errorMessage);
  };

  const handleInputValue = (value) => {
    handleOrderConfirmationSuccess(value, "");
  };
  const resetAlert = () => {
    setIsAlert(false);
  };

  const handleConfirm = async () => {
    if (approval?.status === "Pending") { toastFunc(Constants.MASTER.TOAST.error, "Rejection approval is pending.", 4000); return; }
    const finalCount =
    parseInt(cummOkCount) +
    parseInt(cummRejectCount);

    if (finalCount !== parseInt(jobcardDetails.quantityPerJobCard)) {
      setIsAlert(true);
    } else {
      // setIsdisabled(true);
      const closeJobCardForm = {
        ...jobcardDetails,
        jobcardStatus: Constants.TRANSACTION_STATUS.OPEN,
        quantityPerJobCard:cummOkCount,
      };
      const param = {};
      param.closeJobCardForm = closeJobCardForm;

      await ItemService.completeJobcard(param).then((item) => {
        if (item?.status === 200) {
          console.log(">> item! completeJobcard", item);
          //message
          if (item) {
            toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
            handleClose();
            // handleInputValue(jobcardDetails.jobcard, "");
          } else {
          }
        } else {
          toastFunc(Constants.MASTER.TOAST.error, item?.message || "Unable to close jobcard.", 4000);
        }
      });
    }
  };

  const OrderConfList = async (jobcard, toDeptCode, order) => {
    if (!toDeptCode) return;
    try {
      let param = {
        url: "getOrderConfListByJobCard",
        page: Constants.TRANSACTION.ORDERCONFIRMATION.name,
        jobcard: jobcard,
        deptCode: toDeptCode,
        order,
      };
      await ItemService.getTransactionListDataById(param).then((item) => {
        if (item?.status === 200 && Array.isArray(item.data)) {
          setApproval(item.approval || null);
          const okfilteredData = item?.data?.filter(
            (item) => item.jobstatus === "OK"
          );
          const rejectfilteredData = item?.data?.filter(
            (item) => item.jobstatus === "REJECT"
          );
          const cumuOkCount = okfilteredData.reduce(
            (sum, item) => sum + Number(item.count),
            0
          );
          const cumuRejecteCount = rejectfilteredData.reduce(
            (sum, item) => sum + Number(item.count),
            0
          );
          setCummOkCount(cumuOkCount);
          setCummRejectCount(cumuRejecteCount);
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      });
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000
      );
    }
  };

  return (
    <main className="ClosecurrentJobCard main" id="main">
      <Form noValidate ref={formRef}>
        <Card className="">
          <Card.Header>
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary btn-xs navigateBackButton"
              onClick={() => navigate("/home")}
            >
              <i class="bi bi-arrow-left back"> </i>
              <span className="back"> {t("msg_common.Back")}</span>
            </Button>

            <h5 className="machineStatusTitle">
              {" "}
              {`Close current JobCard - ${jobcardDetails?.jobcard}`}
            </h5>

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
              <p className="bg-table-status bg-table-warning-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.INPROGRESS && (
              <p className="bg-table-status bg-table-success-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}

            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.STOPPED && (
              <p className="bg-table-status bg-table-danger-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}
          </Card.Header>
          <Card.Body className="ps-3">
            <RejectionApprovalNotice approval={approval} onRefresh={() => OrderConfList(jobcardDetails.jobcard, jobcardDetails.toDeptCode, jobcardDetails.order)} />
            <Card>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <ListGroup variant="flush" className="jobcard-detail-list">
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.customer")} :{" "}
                      </span>{" "}
                      {jobcardDetails.customerCode}{" "}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.requiredDate")} :{" "}
                      </span>{" "}
                      {jobcardDetails.requiredDate}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.plan")} :{" "}
                      </span>{" "}
                      {jobcardDetails.planType}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.batchQuantity")}{" "}
                        :{" "}
                      </span>{" "}
                      <p
                        className="bg-table-status bg-table-new-status"
                        style={{ display: "inline" }}
                      >
                        <b>{jobcardDetails.quantityPerJobCard}</b> -{" "}
                        {parseInt(cummOkCount) + parseInt(cummRejectCount)} ={" "}
                        {parseInt(jobcardDetails.quantityPerJobCard) -
                          (parseInt(cummOkCount) + parseInt(cummRejectCount))}
                      </p>
                    </ListGroup.Item>
                    {jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                      <ListGroup.Item className="m-2"></ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <ListGroup variant="flush" className="jobcard-detail-list">
                    <ListGroup.Item>
                      <span>{"Jobcard Number"} : </span>{" "}
                      {jobcardDetails.jobcard}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.msg_generatejobcard.size")} :{" "}
                      </span>{" "}
                      {jobcardDetails.sizeCode} ({jobcardDetails.sizeName})
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>{"Machine"} : </span> {jobcardDetails.toMachineCode}{" "}
                      - {jobcardDetails.toMachineName}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span>
                        {t("msg_trasaction.startstop_jobcard.total_quantity")} :{" "}
                      </span>{" "}
                      {jobcardDetails.batchTotalQuantity}
                    </ListGroup.Item>
                    {jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                      <ListGroup.Item></ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
              </Row>
            </Card>

            <Row>
              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="success"
                  key={""}
                  text={"success"}
                  className="mb-2"
                  style={{ width: "18rem" }}
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">{cummOkCount}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">{okActualAmount}</div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="success"
                      className="btn btn-success"
                      size="lg"
                    >
                      {"OK QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>

              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="danger"
                  key={""}
                  text={"white"}
                  style={{ width: "18rem" }}
                  className="mb-2"
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">{cummRejectCount}</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">
                            {rejectActualAmount}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="danger"
                      className="btn btn-danger"
                      size="lg"
                    >
                      {"REJECT QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>

              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="warning"
                  key={""}
                  text={"white"}
                  className="mb-2"
                  style={{ width: "18rem" }}
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">0000</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">0000</div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="warning"
                      className="btn btn-warning"
                      size="lg"
                    >
                      {"REWORK QTY"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
              <Col
                className="d-flex justify-content-center"
                lg={3}
                md={3}
                sm={12}
              >
                <Card
                  border="info"
                  key={""}
                  text={"white"}
                  style={{ width: "18rem" }}
                  className="mb-2"
                >
                  <Card.Body>
                    <div class="card-body-row row">
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-left">
                          <strong class="column-card-heading">CUMML</strong>
                          <div class="oc-header-value">0000</div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="oc-header-right">
                          <strong class="column-card-heading">ACTUAL</strong>
                          <div class="oc-header-value">0000</div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                  <Card.Footer className="order-conf-footer">
                    <Button
                      type="button"
                      variant="info"
                      className="btn btn-info"
                      size="lg"
                    >
                      {"CONSUMABLES"}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          </Card.Body>

          {
            <Card.Footer className="text-center machine-status-footer-button">
              <Button
                type="button"
                variant="success"
                size="lg"
                className="btn btn-success"
                data-dismiss="modal"
                disabled={approval?.status === "Pending"} onClick={() => handleConfirm()}
              >
                {"CLOSE JOBCARD"}
              </Button>

              <Button
                type="button"
                variant="danger"
                size="lg"
                className="btn btn-danger"
                onClick={() => navigate("/home")}
                data-dismiss="modal"
              >
                {t("msg_common.set_cancel")}
              </Button>
            </Card.Footer>
          }
        </Card>
        {open && (
          <StartStopJobCardModal
            show={open}
            onHide={handleClose}
            handleSuccess={handleOrderConfirmationSuccess}
            handleError={handleOrderConfError}
            onButtonClick={handleInputValue}
            title={"Scan to Close Job card"}
            pageId={"ClosecurrentJobCard"}
            //onSave={handleSave}
          ></StartStopJobCardModal>
        )}
      </Form>
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_trasaction.startstop_jobcard.on_confirm_error")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
      {okQtyModal && (
        <OkQuantityModal
          show={setOkQtyModal}
          onHide={handleModalClose}
          title={okModalTitle}
          jobStatusCode={okModalType}
          deptCode={toDeptCode}
          accumulateActualValue={getActualAmount}
        ></OkQuantityModal>
      )}
    </main>
  );
};

export default ClosecurrentJobCard;
